/**
 * Price Table
 * @since 2019-10-18
 * Modify by Chula: Add name space and module pattern.
 */

(function($) {
    var PriceTable = {
        /**
         * Update navigation state
         * ใช้สำหรับอัปเดตสถานะของอินเตอร์เฟสตัวนำทาง ว่าต้องแสดงปุ่ม Next หรือ Prev เมื่อไร
         * 
         * @param HTMLElement container
         * @param HTMLElement wrapper
         * @returns void
         */
        updateNavigationState: function(container, wrapper) {
            var scroll = {
                width: wrapper.scrollWidth,
                height: wrapper.scrollHeight,
                top: wrapper.scrollTop,
                left: wrapper.scrollLeft
            }

            if (scroll.left === 0) {
                container.classList.add('price-table-container--start')
            } else {
                container.classList.remove('price-table-container--start')
            }

            if (scroll.width <= scroll.left + container.clientWidth) {
                container.classList.add('price-table-container--end')
            } else {
                container.classList.remove('price-table-container--end')
            }
        },
        
        /**
         * Binding event to price table
         * ใช้สำหรับ bind JavaScript event เข้ากับตารางราคา
         * 
         * @param HTMLElement $table
         * @returns void
         */
        bindEvents: function( $table ) {
            var $wrap = $table.querySelector('.price-table-wrapper');
            var $next = $table.querySelector('.price-table-navigation-next');
            var $prev = $table.querySelector('.price-table-navigation-prev');
            var numofitems = $wrap.querySelector('tbody tr').childElementCount;
            var numofshow = $('#number-of-rates-to-display-in-vertical').val();
            
            window.addEventListener('load', () => this.updateNavigationState( $table, $wrap ));
            $wrap.addEventListener('scroll', () => this.updateNavigationState( $table, $wrap ));

            var timer;
            window.addEventListener('resize', () => {
                clearTimeout(timer);
                timer = setTimeout(() => {
                  this.updateNavigationState( $table, $wrap );
                }, 150);
            });

            $next.addEventListener('click', (e) => {
                e.preventDefault();
                console.log(e);
                console.log( $wrap.scrollWidth, numofitems, numofshow );
                // Next
                let scrollByWidth = $wrap.scrollWidth / numofitems * (parseInt(numofshow))
                $($wrap).animate({
                        scrollLeft: `+=${scrollByWidth}`,
                }, scrollByWidth / 2);                
            })

            $prev.addEventListener('click', (e) => {
                e.preventDefault();
                console.log(e);
                // Prev
                let scrollByWidth = $wrap.scrollWidth / numofitems * (parseInt(numofshow))
                $($wrap).animate({
                        scrollLeft: `-=${scrollByWidth}`,
                }, scrollByWidth / 2);
            });
        },
        
        /**
         * Init pricing table
         * 
         * @returns void
         */
        init: function () {
            var $tables = document.querySelectorAll('.price-table-container');
            $tables.forEach($table => {
                var $wrap = $table.querySelector('.price-table-wrapper');
                var isInitialized = $table.classList.contains('initialized');
              
                if (!isInitialized) {
                    this.bindEvents( $table );
                }
              
                this.updateNavigationState( $table, $wrap );
                $table.classList.add('initialized');
            });
        }
    };
    
    if (undefined === window.TL) window.TL = {};
    if (undefined === window.TL.ui) window.TL.ui = {};
    
    $.extend(true, window.TL.ui, {
        PriceTable: PriceTable
    });
    
    window.TL.ui.PriceTable.init();
})(jQuery);
